/**
 * Yatay scroll'u (`scroll.x`) olan antd Table'lar için `sticky` yapılandırması: sayfa aşağı
 * kaydırıldığında kolon başlığını ve yatay scroll bar'ını görünür alanda tutar, böylece kullanıcı
 * scroll bar'a ulaşmak için önce sayfa sonuna inmek zorunda kalmaz.
 *
 * getContainer: uygulamanın dikey scroll'u window'da değil `.gx-layout-content` içinde oluşuyor
 * (`overflow-x: hidden` bu elemanı scroll container'a çeviriyor). rc-table varsayılan olarak window
 * scroll'unu dinlediği için container açıkça verilmeli; aksi halde tablo tamamen görünür hale
 * geldiğinde sticky bar gizlenmez ve tablonun kendi scroll bar'ıyla birlikte iki bar görünür.
 *
 * offsetScroll: bar'ın görünür alanın alt kenarından yükseltileceği mesafe. rc-table sticky
 * sarmalayıcının yüksekliğini `getScrollBarSize()` ile veriyor; overlay scrollbar kullanan
 * ortamlarda bu 0 döndüğü için 8px'lik bar'ın alt yarısı ekran dışında kalıyor. 4px yükseltmek
 * bar'ı her iki ortamda tamamen görünür kılıyor.
 *
 * offsetHeader verilmez (varsayılan 0): offset bu container'ın üst kenarına göre ölçülür ve
 * container zaten sabit topbar'ın altında başlar; 72px eklemek başlığı 72px aşağıda yapıştırır.
 */
export const TABLE_STICKY = {
  getContainer: () => document.querySelector('.gx-layout-content'),
  offsetScroll: 4,
};
